import React from 'react'
import PropTypes from 'prop-types'

import './Columns.css'

const Columns = ({ number, children, disableReverse }) => {
  return (
    <div
      className={
        `fmbm-columns fmbm-columns--${number}` +
        (disableReverse ? ' fmbm-columns--disable-reverse' : '')
      }
    >
      {children}
    </div>
  )
}

Columns.propTypes = {
  number: PropTypes.number.isRequired,
}

export default Columns



// WEBPACK FOOTER //
// ./src/Components/Columns/Columns.js